import { render } from "./ModalTissBatchReopen.vue?vue&type=template&id=b733cc0c&scoped=true"
import script from "./ModalTissBatchReopen.vue?vue&type=script&lang=js"
export * from "./ModalTissBatchReopen.vue?vue&type=script&lang=js"

import "./ModalTissBatchReopen.vue?vue&type=style&index=0&id=b733cc0c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b733cc0c"]])

export default __exports__